<template>
  <div id="AuthorDetails">
    <div class="AuthorDetails">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span class="aqt_lang_mn titlefont">{{ $t('m.details') |U2M}}</span>
        </p>
        <p></p>
      </div>
      <div class="content_a">
        <div class="author">
          <img v-lazy="dataInfor.imgm?$webcrypto.get(dataInfor.imgm):''">
          <div class="name_year" v-if="dataInfor">
            <div v-if="dataInfor.name_lang.mn" class="name aqt_lang_mn titlefont">
              {{ dataInfor.name_lang.mn ? dataInfor.name_lang.mn : dataInfor.name_lang.zh | U2M }}
            </div>
            <div v-else class="name aqt_su titlefont">
              {{ dataInfor.name_lang.zh ? dataInfor.name_lang.zh : '' }}
            </div>
            <div class="year aqt_lang_mn titlefont">{{ dataInfor.birthday?dataInfor.birthday:''|U2M }}    {{ dataInfor.birthday ? 'ᠤᠨ' : ''| U2M }}</div>
          </div>
        </div>
        <div class="deail_content aqt_lang_mn contentfont" :style="{ display: flex}" v-if="dataInfor.content_lang&&dataInfor.content_lang.mn"
             v-html="U2M(dataInfor.content_lang.mn)"></div>
        <div class="deail_content aqt_su contentfont" :style="{ display: flex}" v-else
             v-html="dataInfor.content_lang?dataInfor.content_lang.zh?dataInfor.content_lang.zh:'':''"></div>

        <div class="detail_rigth" v-if="DataList.length">
          <div class="title aqt_lang_mn titlefont">{{ 'ᠪᠦᠲᠦᠭᠡᠯ'|U2M }}</div>
          <div class="rigth_list">
            <div class="list_item" v-for="item in DataList" :key="item.book_id" @click="goBookInfo(item.book_id,item)">
              <img class="img" v-lazy="item.img?$webcrypto.get(item.img):''" alt=""/>
              <div v-if="item.name_lang&&item.name_lang.mn" class="name aqt_lang_mn titlefont">
                {{ item.name_lang.mn | U2M }}
              </div>
              <div v-else class="name aqt_su titlefont">
                {{ (item.name_lang&&item.name_lang.zh) ? item.name_lang.zh : '' }}
              </div>
            </div>

            <div style="clear: both"></div>
          </div>
        </div>
        <div class="detail_rigth" v-if="qkDataList.length">
          <div class="title aqt_lang_mn titlefont">{{ 'ᠰᠡᠳᠭᠥᠯ'|U2M }}</div>
          <div class="rigth_list">
            <div class="list_item" v-for="item in qkDataList" :key="item.book_id" @click="goBookInfo(item.book_id,item)">
              <img class="img" v-lazy="item.img" alt=""/>
              <div v-if="item.name_lang&&item.name_lang.mn" class="name aqt_lang_mn titlefont">
                {{ item.name_lang.mn | U2M }}
              </div>
              <div v-else class="name aqt_su titlefont">
                {{ (item.name_lang&&item.name_lang.zh) ? item.name_lang.zh : '' }}
              </div>
            </div>

            <div style="clear: both"></div>
          </div>
        </div>
        <div class="detail_rigth" v-if="qkmluDataList.length">
          <div class="title aqt_lang_mn titlefont">{{ 'ᠦᠭᠦᠯᠡᠯ'|U2M }}</div>
          <div class="rigth_list">
            <div class="list_item" v-for="item in qkmluDataList" :key="item.book_id" @click="goBookInfo(item.book_id,item)">
              <img class="img" v-lazy="item.img" alt=""/>
              <div v-if="item.name_lang&&item.name_lang.mn" class="name aqt_lang_mn titlefont">
                {{ item.name_lang.mn | U2M }}
              </div>
              <div v-else class="name aqt_su titlefont">
                {{ (item.name_lang&&item.name_lang.zh) ? item.name_lang.zh : '' }}
              </div>
            </div>

            <div style="clear: both"></div>
          </div>
        </div>
        <!--    加载动画-->
        <AqtSpin v-if="isSpin"></AqtSpin>
      </div>
    </div>
<!--    <goback style="top:30px!important;right: 90px!important;"></goback>-->
  </div>
</template>
<script>
export default {
  props:{
    infoId:{
      type:[String,Number],
      default:''
    }
  },
  data() {
    return {
      flex:'block',
      dataInfor: "",
      DataList: [],
      total: 0,
      current_page: 1,
      per_page: 0,
      valdata: {
        library_id: [],
        author_id: this.infoId,
      },
      isSpin:false,
      qkDataList:[],//期刊
      qkmluDataList:[],//期刊目录论文
    }
  },
  methods: {
    getvideodetail() {
      let that = this;
      that.isSpin = true
      let cond = {
        author_id:that.infoId
      }
      that.$httpsencrypt
          .post(`api/web/v3/author/newsinfo`,cond)
          .then((val) => {
            that.dataInfor = val.data;

            //作者书籍的宽度
            that.$nextTick(() => {
              const box = document.querySelectorAll('.deail_content');
              setTimeout(function (){
                for (let i = 0; i < box.length; i++) {
                  let width = 0
                  for (let j = 0; j < box[i].children.length; j++) {
                    width += box[i].children[j].offsetWidth
                  }
                  if(box[i].children.length == 0){
                    that.flex = 'table';
                  }else{
                    that.flex = 'block';
                    box[i].style.width = width + 40 + 'px'
                  }
                }
              },500);
            })
            //作者姓名的宽度
            that.$nextTick(() => {
              const boxa = document.querySelectorAll('.name_year');
              for (let i = 0; i < boxa.length; i++) {
                let width = 0
                for (let j = 0; j < boxa[i].children.length; j++) {
                  width += boxa[i].children[j].offsetWidth
                }
                boxa[i].style.width = width + 40 + 'px'
              }
            })



            that.valdata.library_id = val.data.library_id
            if (val.data.library_id) {
              that.queryData()
            }else {
              that.isSpin = false
            }
          })
          .catch((err) => {
            that.isSpin = false
          });
    },
    queryData() {
      let that = this;
      that.isLoads = false;
      this.$httpsencrypt
          .post("api/web/v3/author/authorotherlist", that.valdata)
          .then((val) => {
            if(val.code==200&&val.data.length){
              that.DataList = val.data.filter(i=>i.type==1)
              that.qkDataList = val.data.filter(i=>i.type==2)
              that.qkmluDataList = val.data.filter(i=>i.type==3)
              that.isSpin = false

            }else {
              that.DataList = []
              that.qkDataList = []
              that.qkmluDataList = []
              that.isSpin = false
            }
          })
          .catch((err) => {
            that.isSpin = false
          });
    },
    getPager(page) {
      let that = this
      that.DataList = []
      that.valdata.page = page
      that.queryData()
    },
    goBookInfo(id,item){
      let that = this
      ///1书籍 2期刊 3论文
      if(item.type==1){
        that.$router.push({
          path:'/BookDetails',
          query:{
            lib_type:sessionStorage.getItem('gcm'),
            id:that.$crypto.set(id),
            title_left:that.$route.query.title_left?JSON.stringify(JSON.parse(that.$route.query.title_left)):''
          }
        })
      }else if(item.type==2){
        that.$router.push({
          path:'/JournalDetails',
          query:{
            lib_type:sessionStorage.getItem('gcm'),
            id:that.$crypto.set(id),
            title_left:that.$route.query.title_left?JSON.stringify(JSON.parse(that.$route.query.title_left)):''
          }
        })

      }else if(item.type==3){
        this.$router.push({
          path:'/JournalMue',
          query:{
            lib_type:sessionStorage.getItem('gcm'),
            id:that.$crypto.set(id),
            title_left:that.$route.query.title_left?JSON.stringify(JSON.parse(that.$route.query.title_left)):''
          }
        })
      }

    }
  },
  created() {
    this.getvideodetail()
  },
  mounted() {
    let info={
      book_id: this.infoId,
      type: 9,
      path: this.$route.path,
      mark: '作者详情',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  }
}
</script>

<style lang="less" scoped>
#AuthorDetails {
  width: 100%;
  height: 100%;
  display: flex;

  .AuthorDetails{
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;
    .left_Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 27px;
      display: flex;
      justify-content: flex-end;

      p:nth-child(1) {
        width: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        width: 4px;
        height: 162px;
        background: var(--themeColor);
        margin-left: 10px;
      }
    }
    .content_a{
      height: 100%;
      background: #ffffff;
      padding: 55px 0px 52px;
      display: flex;
      position: relative;
      .author{
        min-width:150px;
        height: 100%;
        border-right:1px solid #EDEDED ;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 119px;
          height: auto;
          border-radius: 10px;
        }
        .name_year {
          width: 100%;
          height: calc(100% - 18rem);
          margin-top: 2rem;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          overflow: hidden;
          .name {
            height: 45rem;
            font-size: 1.9rem;
            font-weight: 500;
            color: #888888;
            //text-align: center;
            overflow: hidden;
            margin-right: 1.5rem;
          }

          .year {
            //text-align: center;
            font-size: 1.5rem;
            font-weight: 400;
            color: #888888;
          }
        }
      }
      .deail_content {
        height: 100%;
        background: #ffffff;
        line-height: 3rem;
        margin-left: 0.2rem;
        font-size: 1.8rem;
        padding: 1.5rem;
        color: #888888;
      }
      .detail_rigth {
        //min-width:10rem;
        //min-width: 258px;
        height: 100%;
        padding: 1.5rem;
        background: #ffffff;
        margin-left: 0.2rem;
        display: flex;

        .title {
          width: 4rem;
          height: 100%;
          font-size: 2rem;
          //font-weight: 600;
          color: #888888;
          margin-right: 1rem;
        }

        .rigth_list {
          //width: 12rem;
          height: 100%;
          writing-mode: vertical-lr;

          .list_item {
            width: 12rem;
            height: 12rem;
            margin-bottom: 0.8rem;
            margin-right: 0.8rem;
            float: left;
            cursor: pointer;

            .img {
              width: 70%;
              height: 100%;
              border-radius: 0.5rem;
            }

            .name {
              width: 20%;
              height: 100%;
              font-size: 1.8rem;
              color: #888888;
              font-weight: 500;
              margin-left: 0.5rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: normal;
              //display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              text-indent: 5px;
            }
          }
        }
        .page {
          width: 50px;
          height: 100%;
          margin-left: 1.5rem;
        }
      }
    }
  }
  .AuthorDetails::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .AuthorDetails::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .AuthorDetails::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
<style lang="less">
#AuthorDetails {
  ul {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;

    li {
      writing-mode: vertical-lr;
      text-orientation: sideways-right;
      text-orientation: sideways !important;
      -o-text-orientation: sideways !important;
      -ms-text-orientation: sideways !important;
      -moz-text-orientation: sideways !important;
      -webkit-text-orientation: sideways !important;
      -webkit-text-orientation: sideways-right !important;
      margin-right: 0 !important;
      margin-bottom: 4px !important;
    }

    .ivu-page-item-active {
      background: var(--themeColor) !important;
      border: 0px solid var(--themeColor) !important;
    }

    .ivu-page-item-active a, .ivu-page-item-active:hover a {
      color: #FFFFFF !important;
    }
  }

  .ivu-page-options {
    margin-left: 0 !important;
    margin-top: 15px !important;
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;

    .ivu-page-options-elevator {
      width: 33px !important;
      height: 100% !important;

      input {
        width: 32px !important;
        height: 50px !important;
        margin: 8px 0 !important;
        display: table-column !important;
        white-space: nowrap;
        line-height: 3.3rem;
        font-weight: unset;
        font-weight: normal;
        text-align: center;
      }
    }
  }
}
</style>
